import { Component } from 'react'
import './MixtilesButtonsDrawer.scss'
import { Drawer } from '@mui/material'
import { DIALOG_Z_INDEX } from 'mixtiles-web-common/elements/Theme/defaultTheme'

class MixtilesButtonsDrawer extends Component {
  render() {
    return (
      <Drawer
        anchor="bottom"
        classes={{ paper: 'drawer' }}
        // Opened from inside dialogs, which the theme stacks above drawers
        sx={{ zIndex: `${DIALOG_Z_INDEX + 1} !important` }}
        open={this.props.open}
        onClose={this.props.onClose}
        keepMounted={!!this.props.keepMounted}
      >
        <div className="buttons">{this.props.children}</div>
      </Drawer>
    )
  }
}

export default MixtilesButtonsDrawer
